'use client';

import { createContext, useContext, ReactNode } from 'react';

export interface StoreSettings {
  id: string;
  organizationId: string;
  distributorId: string;
  displayName: string;
  themeColor: string;
  bannerImage?: string;
  baseUrl: string;
  isPublic: boolean;
  announcementBar?: string;
  featuredCategories?: string[];
  deliveryWindows?: {
    cutoffTime: string;
    deliveryDay: string;
  }[];
  contactEmail?: string;
  contactPhone?: string;
  // Feature flags
  showRecipes: boolean;
  showDeliverySchedule: boolean;
  showBuyAgain: boolean;
  showReturns: boolean;
  showSupport: boolean;
  showChat: boolean;
}

const StoreContext = createContext<StoreSettings | null>(null);

export const StoreProvider = ({ 
  settings, 
  children 
}: { 
  settings: StoreSettings; 
  children: ReactNode;
}) => {
  return (
    <StoreContext.Provider value={settings}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};